import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import theme from 'src/styles/components/OrderSummaryTile.module.scss';

const OrderSummaryTile = React.memo(({
    clients,
    fingerprint,
    summary,
    sumTranslationKey
}) => {
    const intl = useIntl();

    return (
        <div className={theme.contentContainer}>
            <div
              className={theme.content}
              role="presentation"
            >
                <div className={classnames(theme.status)}>
                    {intl.formatMessage({ id: `Order.receipt` })}
                </div>
                <div className={theme.clients}>
                    {clients.map((client) => (
                        <div
                          key={client.fingerprint}
                          className={classnames(theme.person, {
                            [theme.isMe]: fingerprint === client.fingerprint
                        })}
                        >
                            <div className={theme.descriptionContainer}>
                                <div className={theme.name}>
                                    {fingerprint === client.fingerprint && (
                                        <>
                                            {intl.formatMessage({ id: 'App.you' })} ({client.name})
                                        </>
                                    )}
                                    {fingerprint !== client.fingerprint && client.name}
                                </div>
                                <div className={theme.positionsCount}>
                                    {intl.formatMessage({ id: 'App.positionsTemplate' }, { positions: client.positionsCount })}
                                </div>
                            </div>
                            <div className={theme.price}>
                                {intl.formatNumber(client.price, { style: 'currency', currency: 'PLN' })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={theme.summary}>
                <div className={theme.descriptionContainer}>
                    {intl.formatMessage({ id: sumTranslationKey })}
                </div>
                <div className={theme.price}>
                    {intl.formatNumber(summary.price, { style: 'currency', currency: 'PLN' })}
                </div>
            </div>
        </div>
    );
});

OrderSummaryTile.propTypes = {
    clients: PropTypes.arrayOf(PropTypes.shape({
        fingerprint: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        positionsCount: PropTypes.number.isRequired,
        price: PropTypes.number.isRequired
    })),
    summary: PropTypes.shape({
        price: PropTypes.number.isRequired
    }),
    fingerprint: PropTypes.string.isRequired,
    sumTranslationKey: PropTypes.string
};

OrderSummaryTile.defaultProps = {
    sumTranslationKey: 'App.billSum'
};

export default OrderSummaryTile;
